var defaultGenerator = function defaultGenerator(componentName) {
  return componentName;
};
var createClassNameGenerator = function createClassNameGenerator() {
  var _generate = defaultGenerator;
  return {
    configure: function configure(generator) {
      _generate = generator;
    },
    generate: function generate(componentName) {
      return _generate(componentName);
    },
    reset: function reset() {
      _generate = defaultGenerator;
    }
  };
};
var ClassNameGenerator = createClassNameGenerator();
var globalStateClassesMapping = {
  active: 'csg-tui-active',
  checked: 'csg-tui-checked',
  completed: 'csg-tui-completed',
  disabled: 'csg-tui-disabled',
  error: 'csg-tui-error',
  expanded: 'csg-tui-expanded',
  focused: 'csg-tui-focused',
  focusVisible: 'csg-tui-focusVisible',
  required: 'csg-tui-required',
  selected: 'csg-tui-selected'
};
function generateUtilityClass(componentName, slot) {
  var globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass || "".concat(ClassNameGenerator.generate(componentName), "-").concat(slot);
}
function generateUtilityClasses(componentName, slots) {
  var result = {};
  slots.forEach(function (slot) {
    result[slot] = generateUtilityClass(componentName, slot);
  });
  return result;
}
function composeClasses(slots, getUtilityClass, classes) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var output = {};
  Object.keys(slots).forEach(
  // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  function (slot) {
    output[slot] = slots[slot].reduce(function (acc, key) {
      if (key) {
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
        acc.push(getUtilityClass(key));
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

export default ClassNameGenerator;
export { composeClasses, generateUtilityClass, generateUtilityClasses };
//# sourceMappingURL=classes.esm.js.map
